/* eslint-disable no-mixed-operators */
import React, { useState } from "react";
import { ListGroup } from "react-bootstrap";
// import { useTranslation } from "react-i18next";

export function generateUUID() { // Public Domain/MIT
    var d = new Date().getTime();//Timestamp
    var d2 = ((typeof performance !== 'undefined') && performance.now && (performance.now() * 1000)) || 0;//Time in microseconds since page-load or 0 if unsupported
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16;//random number between 0 and 16
        if (d > 0) {//Use timestamp until depleted
            r = (d + r) % 16 | 0;
            d = Math.floor(d / 16);
        } else {//Use microseconds since page-load if supported
            r = (d2 + r) % 16 | 0;
            d2 = Math.floor(d2 / 16);
        }
        return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
}

function MultiselectPage(props) {

    //const { t } = useTranslation();
    const [type, setType] = useState("");
    const [cursor, setCursor] = useState(null);
    const uuid = generateUUID();

    let dataList = [];
    // Getting the list maintain in array
    if (props?.showList && props?.list?.length > 0) {
        dataList = props?.list?.filter((label) => {
            const data =
                label?.label
                    ?.toLowerCase()
                    ?.includes(type?.toLowerCase());
            return data;
        });
    }

    const displayList = (e) => {
        props?.setShowList(true);
        if(document.getElementById(uuid)){
            document.getElementById(uuid).focus();
        }
        setCursor(0);
    }

    const GotoMain = (value) => {
        if (dataList?.length > 0 && props?.showList) {
            const elses = document.getElementById(uuid + cursor);
            if (elses)
                document.getElementById('category-lists' + uuid).scrollTo({ top: elses.offsetTop + value, behavior: 'smooth' })
        }
    }

    const handleKeyDown = (e) => {
        if (props?.list > 0) {
            props?.setShowList(true);
        }
        if (e.key === 'Enter') {
            e.preventDefault();
            if (dataList?.length > 0 && props?.showList) {
                callOnSelect(e, dataList[cursor], cursor)
            }
        } else if (e.keyCode === 38 && cursor > 0) {
            setCursor(cursor - 1);
            GotoMain(-50)
        } else if (e.keyCode === 40 && cursor < dataList.length - 1) {
            GotoMain(+10)
            setCursor(cursor + 1);
        }
    }

    const ResetState = () => {
        props?.setShowList(false);
        setCursor(0);
    }

    const callOnSelect = (e, item, index) => {
        e.preventDefault();
        e.stopPropagation();
        setCursor(0);
        props?.groupItemClick(e, item, index);
        setType("");
        props?.setShowList(false);
    }

    const onChangeHandler = (e) => {
        setType(e.target.value)
        props?.setShowList(true);
    }

    return (
        <div className="transition position-relative multi-select-catlist" >
            <label htmlFor={uuid} className="custom-multi-select" onClick={displayList} >
                <div className="first-area">
                    {props?.sublist?.map((item, index) => item?.label && (
                        <div key={index.toString()} className="parent-content">
                            <div className="content-value">{item?.label}</div>
                            <div role="button" className="cross-icon" onClick={(e) => props?.remove(e, item)}>
                                <svg height="14" width="14" viewBox="0 0 20 20" focusable="false" className="cross-icon-svg">
                                    <path d="M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z">
                                    </path>
                                </svg>
                            </div>
                        </div>
                    ))}
                    <div className="input-area">
                        <input
                         id={uuid}
                         onKeyDown={handleKeyDown}
                         placeholder={props?.sublist?.length > 0 ? "" : props?.placeholder}
                         value={type}
                         type="text"
                         className="input-field"
                         onChange={onChangeHandler}
                        />
                    </div>
                </div>
                <div className="second-area">
                    {props?.sublist?.length > 0 && (
                        <div className="cross-logo" onClick={(e) => props?.clearSelected(e, props?.sublist)}>
                            <svg height="20" width="20" viewBox="0 0 20 20" focusable="false" className="cross-logo-svg">
                                <path d="M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"></path>
                            </svg>
                        </div>
                    )}
                    <span className="vertical-line"></span>
                    <div className="down-arrow-logo">
                        <svg height="20" width="20" viewBox="0 0 20 20" focusable="false" className="down-arrow-svg"><path d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"></path></svg>
                    </div>
                </div>
            </label>
            {props?.showList && dataList?.length > 0 && (
                <React.Fragment>
                    {dataList?.length > 0 &&
                        <ListGroup id={'category-lists' + uuid} className={"custom-category-list"}>
                            {dataList?.map((item, index) => (
                                <ListGroup.Item
                                    active={props?.value === item?.label}
                                    className={cursor === index ? "actives" : "unactives"}
                                    id={uuid + index}
                                    onClick={e => callOnSelect(e, item, index)}
                                    key={index.toString()}
                                >
                                    {item?.label}
                                </ListGroup.Item>
                            ))}
                        </ListGroup>}
                    {dataList?.length > 0 && <div onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        ResetState()
                    }} className="background_click" />}
                </React.Fragment>
            )}
        </div>
    );
}
export default MultiselectPage;